export default function fixedHeader() {
  const header = document.querySelector('header');
  let scrollObject = {};

  if (!header) {
    return false;
  }

  function getScrollPosition() {
    scrollObject = {
      x: window.pageXOffset,
      y: window.pageYOffset,
    };
    if (scrollObject.y > 0.1) {
      header.classList.add('header--scroll');
    } else {
      header.classList.remove('header--scroll');
    }
  }

  getScrollPosition();

  window.addEventListener('scroll', getScrollPosition);

}